<template>
    <div class="my-4">
        <div
            class="flex flex-col md:flex-row justify-between items-start md:items-center"
        >
            <h1 class="text-3xl">
                Variantes
                <strong class="text-theme-primary">destacadas</strong>
            </h1>
            <small class="text-theme-muted mt-1 md:mt-0">
                Selecciona el tipo y la categoría para gestionar el destacado
            </small>
        </div>

        <div class="mt-6 p-4 rounded-lg border border-brand-blue">
            <p class="text-sm text-theme-muted mb-3"></p>
            <div class="flex flex-wrap">
                <div class="w-full md:w-1/2 md:pr-2">
                    <reference-highlight-type-selector
                        v-model="highlightType"
                        enabled
                        label=""
                    />
                </div>
                <div class="w-full md:w-1/2 md:pl-2 mt-4 md:mt-0">
                    <subline-selector
                        v-model="line"
                        add-root
                        enabled
                        @focus="onFocus"
                    />
                </div>
            </div>
            <div class="flex justify-end mt-4">
                <app-button relief @click="listHighlightReferencesComponent">
                    Consultar 🔎
                </app-button>
            </div>
        </div>

        <template v-if="isQuery">
            <div class="mt-6">
                <div class="flex items-center justify-between mb-3">
                    <h3 class="text-lg">Agregar referencias al destacado</h3>
                    <span
                        v-if="references.length"
                        class="text-sm text-theme-muted"
                    >
                        {{ references.length }} referencia{{
                            references.length !== 1 ? "s" : ""
                        }}
                        seleccionada{{ references.length !== 1 ? "s" : "" }}
                    </span>
                </div>
                <references-search-scanner
                    :default-filters="{ active: true }"
                    :enabled-scanner="enabledScanner"
                    @input="validatePushReferences"
                />
            </div>
            <div
                v-if="!references.length"
                class="mt-4 py-10 text-center text-theme-muted"
            >
                Sin referencias destacadas. Usa el buscador para agregar.
            </div>
            <div class="mt-4">
                <references-cards v-model="references" />
                <div class="flex justify-end mt-4 mb-6">
                    <app-button
                        color="success"
                        @click="updateHighlightReferencesComponent"
                    >
                        Guardar cambios ✔
                    </app-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { ROOT_LINE_NAME } from "@/common/constants";

import SublineSelector from "@/components/lines/SublineSelector.vue";
import ReferenceHighlightTypeSelector from "@/components/products/ReferenceHighlightTypeSelector.vue";
import ReferencesCards from "@/components/references/ReferencesCards.vue";
import ReferencesSearchScanner from "@/components/references/ReferencesSearchScanner.vue";

export default {
    name: "HighlightReferences",
    components: {
        SublineSelector,
        ReferenceHighlightTypeSelector,
        ReferencesCards,
        ReferencesSearchScanner
    },
    data: () => ({
        highlightType: "highlight",
        isLoading: true,
        references: [],
        isQuery: false,
        line: {
            slug: "",
            name: ROOT_LINE_NAME
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        enabledScanner: true
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("reference:ListHighlight", "/app")))
            return;
        this.listItems(true);
    },
    methods: {
        ...mapActions("products", [
            "listHighlightReferences",
            "updateHighlightReferences"
        ]),
        async listHighlightReferencesComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.references = await this.listHighlightReferences({
                    type: this.highlightType,
                    lineSlug: this.line ? this.line.slug : null
                });
                this.isQuery = true;
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateHighlightReferencesComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateHighlightReferences({
                    lineSlug: this.line.slug ?? null,
                    type: this.highlightType,
                    referencesIds: this.references.map((item) => item.id)
                });
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        validatePushReferences(reference) {
            const index = this.references.findIndex(
                (item) => item.id === reference.id
            );
            if (index === -1) {
                this.references.unshift(reference);
            }
        },
        onFocus() {
            this.enabledScanner = false;
        },
        onBlur() {
            this.enabledScanner = true;
        }
    }
};
</script>
